import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MarketTileAthPercentage = ({ data, formatNumber, animate, bitcoinPrice }) => {
  const apiAth = data?.s06?.bitcoin?.market_data?.ath?.usd;
  
  // Use the higher value between API ATH and current bitcoin price
  const actualAth = apiAth != null && bitcoinPrice != null 
    ? Math.max(apiAth, bitcoinPrice)
    : apiAth ?? bitcoinPrice;
  
  // Calculate percentage from ATH using current bitcoin price
  const percentageFromAth = actualAth != null && bitcoinPrice != null
    ? ((bitcoinPrice - actualAth) / actualAth) * 100
    : data?.s06?.bitcoin?.market_data?.ath_change_percentage?.usd;
  
  const numberValue = percentageFromAth != null
    ? `${formatNumber(percentageFromAth, 2)}%`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="% From ATH" value={numberValue} />
    </ThemedFlex>
  );
};
